import urlJoin from 'url-join';

/**
 *
 * buildUrl([{ projects: 10 }, { skills: 2020 }]) => /projects/10/skills/2020
 * buildUrl([{ projects: 10 }])                   => /projects/10
 * buildUrl('collaborators')                      => /collaborators
 * @param {Array,String} params
 *
 */
export const buildUrl = params => {
  let url = '/';

  if (!params) {
    return url;
  }

  if (typeof params === 'string' || params instanceof String) {
    url = urlJoin(url, params);
  } else if (Array.isArray(params)) {
    params.forEach(param => {
      const paramKey = Object.keys(param)[0];
      const paramValue = param[paramKey] ? param[paramKey].toString() : null;

      if (paramKey) {
        url = urlJoin(url, paramKey);
        if (paramValue) {
          url = urlJoin(url, paramValue);
        }
      }
    });
  }

  return url;
};
